import React from "react";
import ArrowOutwardRounded from "@mui/icons-material/ArrowOutwardRounded";
import PhoneOutlined from "@mui/icons-material/PhoneOutlined";
import * as S from "./Styles";

interface OverlayMenuProps {
  isOpen: boolean;
  closeMenu: () => void;
}

const OverlayMenu = ({ isOpen, closeMenu }: OverlayMenuProps) => {
  const menuItems = [
    { label: "Hjem", to: "/", number: "01" },
    { label: "Om oss", to: "/om-oss", number: "02" },
    { label: "Kontakt", to: "/kontakt", number: "03" },
  ];

  return (
    <S.Overlay id="mobile-navigation" $isOpen={isOpen} aria-hidden={!isOpen}>
      <S.MenuContent $isOpen={isOpen}>
        <S.MenuIntro>
          <S.Eyebrow>Grønvold Byggservice</S.Eyebrow>
          <S.Heading>Godt håndverk, fra første møte til siste detalj.</S.Heading>
        </S.MenuIntro>
        <S.MenuList>
          {menuItems.map((item) => (
            <S.MenuEntry key={item.to}>
              <S.MenuItem onClick={closeMenu} to={item.to}>
                <S.MenuNumber>{item.number}</S.MenuNumber>
                <S.MenuLabel>{item.label}</S.MenuLabel>
                <ArrowOutwardRounded aria-hidden="true" />
              </S.MenuItem>
            </S.MenuEntry>
          ))}
        </S.MenuList>
        <S.MenuFooter>
          <S.PhoneLink href="tel:+4746905066">
            <PhoneOutlined aria-hidden="true" />
            469 05 066
          </S.PhoneLink>
          <S.ConsultationLink to="/kontakt" onClick={closeMenu}>
            Bestill gratis befaring
            <ArrowOutwardRounded aria-hidden="true" />
          </S.ConsultationLink>
        </S.MenuFooter>
      </S.MenuContent>
    </S.Overlay>
  );
};

export default OverlayMenu;
